import { getOrCreateSessionId } from './session';

const impressedKeys = new Set<string>();

export const hasImpressed = (entityType: string, entityId: string): boolean => {
  const sessionId = getOrCreateSessionId();
  return impressedKeys.has(`${sessionId}:${entityType}:${entityId}`);
};

export const markImpressed = (entityType: string, entityId: string): void => {
  const sessionId = getOrCreateSessionId();
  impressedKeys.add(`${sessionId}:${entityType}:${entityId}`);
};
